import { Table } from "../UI/Table";
import Text from "../UI/Text";
// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
import type { LigneAmortissement } from "../../models/tableauAmortissement";
import styles from "./PretTable.module.css";

interface PretPreviewTableProps {
  lignes?: LigneAmortissement[];
  isPreview?: boolean;
}

export default function PretTable({
  lignes,
  isPreview = false,
}: PretPreviewTableProps) {
  if (!lignes || lignes.length === 0) {
    return <Text color="muted">Aucune ligne à afficher</Text>;
  }
  let lignesToDisplay = lignes;
  if (isPreview) {
    lignesToDisplay = lignes.slice(0, 5);
  }

  return (
    <>
      <Table variant="card" className={styles.table}>
        <Table.Header>
          <Table.Column>Date</Table.Column>
          <Table.Column align="right">Capital</Table.Column>
          <Table.Column align="right">Intérêts</Table.Column>
          <Table.Column align="right">Assurance</Table.Column>
          <Table.Column align="right">Frais</Table.Column>
          <Table.Column align="right">Mensualité</Table.Column>
          <Table.Column align="right">Capital&nbsp;restant</Table.Column>
        </Table.Header>
        <Table.Body>
          {lignesToDisplay.map((ligne, index) => (
            <Table.Row key={index}>
              <Table.Cell>{ligne.date}</Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.capital)}
              </Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.interets)}
              </Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.assurance)}
              </Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.frais_dossier || 0)}
              </Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.mensualite_totale)}
              </Table.Cell>
              <Table.Cell align="right">
                {currencyFormatter(ligne.capital_restant_du)}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {isPreview && (
        <Text color="muted" className="text-center marginT5">
          Aperçu des 5 premières lignes
        </Text>
      )}
    </>
  );
}
